<template>
    <div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("khanDistrict.cityProvince")
                }}</label>
                <Select
                    v-model="model.province_code"
                    :placeholder="$t('khanDistrict.cityProvince')"
                    :class="{ 'is-invalid': errors.has('province_code') }"
                >
                    <Option
                        v-for="province in provinces"
                        :key="province.province_code"
                        :value="province.province_code"
                    >
                        {{ province.name_en }}
                    </Option>
                </Select>
                <div
                    class="invalid-feedback"
                    v-if="errors.has('province_code')"
                >
                    {{ errors.first("province_code") }}
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("khanDistrict.nameKh")
                }}</label>
                <input
                    v-model.trim="model.name_kh"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('name_kh') }"
                    ref="name_kh"
                />
                <div class="invalid-feedback" v-if="errors.has('name_kh')">
                    {{ errors.first("name_kh") }}
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("khanDistrict.nameEn")
                }}</label>
                <input
                    v-model.trim="model.name_en"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('name_en') }"
                />
                <div class="invalid-feedback" v-if="errors.has('name_en')">
                    {{ errors.first("name_en") }}
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh">
                <ts-button
                    @click.prevent="() => $emit('cancel')"
                    class="btn-gray"
                    >{{ $t("cancel") }}</ts-button
                >
                <ts-button
                    v-if="!isUpdate"
                    color="primary"
                    outline
                    :waiting="waiting_new"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onSaveAddNew"
                    >{{ $t("saveAddNew") }}</ts-button
                >
                <ts-button
                    color="primary"
                    v-if="!isUpdate"
                    :waiting="waiting"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onSave"
                    >{{ $t("save") }}</ts-button
                >
                <ts-button
                    v-if="isUpdate"
                    color="primary"
                    @click.prevent="onUpdate"
                    :waiting="waiting"
                    >{{ $t("update") }}</ts-button
                >
            </div>
        </div>
        <Spin size="large" fix v-if="loading"> </Spin>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
import { isEmpty } from "lodash";

export default {
    name: "khan-districtForm",
    data() {
        return {
            errors: new Errors(),
            loading: false,
            waiting: false,
            waiting_new: false,
            provinces: [],
            model: {
                province_code: null,
                name_kh: null,
                name_en: null
            }
        };
    },
    computed: {
        ...mapState("corporate/khanDistrict", ["edit_data"]),
        isUpdate() {
            return !isEmpty(this.edit_data);
        }
    },
    methods: {
        fetchProvinces() {
            this.$store
                .dispatch("corporate/khanDistrict/getCityProvince")
                .then(response => {
                    this.provinces = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                });
        },
        async onSaveAddNew() {
            this.errors = new Errors();
            this.waiting_new = true;
            this.$store
                .dispatch("corporate/khanDistrict/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("fetchData");
                    this.clearInput();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting_new = false;
                });
        },
        async onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("corporate/khanDistrict/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        onUpdate() {
            this.waiting = true;
            this.$store
                .dispatch("corporate/khanDistrict/update", {
                    id: this.edit_data.district_code,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        setEditData() {
            this.fetchProvinces();
            this.$nextTick(function() {
                this.$refs.name_kh.focus();
            });
            if (!isEmpty(this.edit_data)) {
                this.model.province_code = this.edit_data.province_code;
                this.model.name_kh = this.edit_data.name_kh;
                this.model.name_en = this.edit_data.name_en;
            }
        },
        clearInput() {
            this.errors = new Errors();
            this.model.province_code = null;
            this.model.name_kh = null;
            this.model.name_en = null;
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "KHAN DISTRICT",
                desc: not.text
            });
        }
    }
};
</script>
